import React from 'react';

const LABELS = {
  active: 'Active',
  disabled: 'Disabled',
  suspended: 'Suspended',
  stale: 'Reporting stale',
  alert: 'Reporting stale',
  draft: 'Draft',
  finalized: 'Finalized',
  paid: 'Paid',
  void: 'Void',
};

/**
 * StatusBadge - thin pill rendering an installation or invoice status.
 * Maps any unknown status to a neutral-ish pill.
 */
export default function StatusBadge({ status, label, className = '' }) {
  const norm = String(status || '').toLowerCase().trim() || 'unknown';
  const text = label || LABELS[norm] || norm.charAt(0).toUpperCase() + norm.slice(1);
  return (
    <span className={`billing-admin__status billing-admin__status--${norm} ${className}`}>
      {text}
    </span>
  );
}
